// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"7ca77abb","193":"44a1afc3","351":"9d88056f","514":"91803d02","539":"6dda7913","622":"a69c7272","641":"5df88093","773":"250e0f92","818":"6221d59c","856":"30711bf2","860":"85cb5d80","965":"def988bf"}[chunkId] + ".chunk.js";
};